<template>
	<div class="xs-12 p4">
		<div class="pb2 fs3 fw7">{{$t("name")}}</div>
		<j-base-input-text class="mb4" size="small" v-model="folderName" />
		<div class="flex xs-12 xs-center">
			<j-button type="primary" size="small" @click="submit">{{$t("submit")}}</j-button>
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText"
import JButton from "@/components/JButton"

export default {
	name: "CreateFolderInput",

	components: { JBaseInputText, JButton },

	data() {
		return {
			folderName: ""
		}
	},

	methods: {
		submit() {
			if (this.folderName.length) {
				this.$emit("input", this.folderName)
			} else {
				this.$store.dispatch("showMessage", ["Cannot create unnamed folder."])
			}
		}
	}
}
</script>